import React, { useState } from 'react';
import { getIn18Text } from 'api';
import { Button } from 'antd';
import './format.scss';
const ModalImg = props => {
    const { showMfEdit, url, id } = props;
    const [active, setActive] = useState(false);
    const handleMouseEnter = () => {
        setActive(true);
    };
    const handleMouseLeave = () => {
        setActive(false);
    };
    return (React.createElement("div", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, className: `mf-img-wrap  ${active ? 'active' : ''}` },
        React.createElement("div", { className: "mf-bg-img", style: { backgroundImage: `url(${url})` } }),
        React.createElement("div", { className: "mf-img-oper-wrap" },
            React.createElement("div", { className: "img-oper" },
                React.createElement(Button, { type: "primary", onClick: () => {
                        showMfEdit(id);
                    } }, getIn18Text('SHIYONG'))))));
};
export default ModalImg;
